import { render } from "./Album202511.vue?vue&type=template&id=323c2970&scoped=true"
import script from "./Album202511.vue?vue&type=script&lang=js"
export * from "./Album202511.vue?vue&type=script&lang=js"

import "./Album202511.vue?vue&type=style&index=0&id=323c2970&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-323c2970"

export default script